module.exports = __webpack_public_path__ + "static/IV-Solution-Logo-543133d15b3731547456a7cd7bb0f492.svg";